import React from 'react';
import { Box } from '@mui/material';
import VideoPlayer from '../../../../components/VideoPlayer';
import appColors from '../../../../common/app_colors';

const WholeMeProfileVideoPlayer = ({ videoUrl }) => (
  <Box
    sx={{
      width: 1,
      overflow: 'hidden',
      '& > div': {
        width: 1,
        height: 1,
      },
      '& img': {
        objectFit: 'contain',
        objectPosition: 'center',
      },
      '& video': {
        width: 'inherit',
        height: 'inherit',
        objectFit: 'cover',
        objectPosition: 'center',
        backgroundColor: appColors.wholeMeAssets.videoPlayerBackground,
      },
    }}
  >
    <VideoPlayer
      videos={[
        {
          uri: videoUrl,
        },
      ]}
      hasFrameThumbnail
    />
  </Box>
);

export default WholeMeProfileVideoPlayer;
